var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hcontent"},[_c('homeMenu',{attrs:{"path":_vm.newpath}}),_c('div',{staticClass:"hcontent_c"},[_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }